import { addWildcardToRoutes, withLocalization } from '@melio/ar-domain';
import { GuestPaymentWithAuthFlow, NewGuestPaymentWithAuthFlow } from '@melio/ar-guest-payment';
import { Route, Routes } from 'react-router-dom';

type ResetAccessTokenFunction = (accessToken?: string, refreshToken?: string | null) => void;

type GuestPaymentRouterProps = {
  WithAnonymousInitialData: React.ComponentType;
  useResetAccessToken: () => ResetAccessTokenFunction;
};

export const GuestPaymentRouter = withLocalization(
  ({ useResetAccessToken, WithAnonymousInitialData }: GuestPaymentRouterProps) => {
    const { Paths } = useGuestPaymentRoutes();

    const GuestPaymentRoute = () => {
      const resetAccessToken = useResetAccessToken();
      const onLoggedIn = (...args: Parameters<ResetAccessTokenFunction>) => {
        resetAccessToken(...args);
        return new Promise<void>((resolve) => setTimeout(resolve, 1));
      };

      return <GuestPaymentWithAuthFlow onLoggedIn={onLoggedIn} />;
    };

    return (
      <Routes>
        <Route element={<WithAnonymousInitialData />}>
          <Route path={Paths.GuestPayment} element={<NewGuestPaymentWithAuthFlow />} />
          {/*remove old routes after dev done*/}
          <Route path={Paths.NewGuestPayment} element={<NewGuestPaymentWithAuthFlow />} />
          <Route path={Paths.OldGuestPayment} element={<GuestPaymentRoute />} />
        </Route>
      </Routes>
    );
  }
);
GuestPaymentRouter.displayName = 'GuestPaymentRouter';

const useGuestPaymentRoutes = () => {
  enum Paths {
    GuestPayment = '',
    NewGuestPayment = 'new',
    OldGuestPayment = 'old',
  }

  return {
    RedirectPaths: Paths,
    Paths: addWildcardToRoutes(Paths),
  };
};
